import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Circle, Path } from '../IconBase/IconBase'

function Assessor({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 18 19' {...props}>
      <Circle
        cx='8.92837'
        cy='6.51822'
        r='3.10025'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.09375 15.0912C3.09375 13.2785 4.56363 11.8086 6.37637 11.8086H8.26059'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.304 14.3495C11.1383 14.1418 11.1383 13.8672 11.304 13.6595C11.817
         13.0179 12.6232 12.5039 13.4294 12.5039C14.2356 12.5039 15.0411 13.0179
          15.5548 13.6589C15.7213 13.8666 15.7213 14.1412 15.5548 14.3489C15.0403
           14.99 14.2349 15.5039 13.4294 15.5039C12.6232 15.5045 11.817 14.9906
            11.304 14.3495Z'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.4429 14.0158C13.4224 14.0158 13.4064 14.0318 13.4064 14.0522C13.4064
         14.0727 13.4224 14.0887 13.4429 14.0887C13.4633 14.0887 13.4793 14.0727 13.4793
          14.0522C13.4793 14.0318 13.4633 14.0158 13.4429 14.0158'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Assessor.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default Assessor
